// extracted by mini-css-extract-plugin
export default {"certificateCard":"WorldRecord_certificateCard__QtCQx"};